module.exports = __webpack_public_path__ + "static/media/aUSDC-logo.99d3189e.png";